export const editInsurancePageTranslations = {
  en: {
    editInsurancePage: {
      continue: 'Continue',
      fillOutNow: 'Fill this out now to save time at your next appointment',
      insuranceProvider: 'Insurance provider',
      memberIdCharacterMinimum: 'Member ID must be at least 1 character',
      memberIdInvalidCharacter: 'Please enter only letters and numbers',
      memberIdInvalidFormat: 'Invalid format, please re-enter',
      ocrIssueTitle:
        'Unable to read your card information. Add the missing information below to continue adding insurance coverage.',
      otherPredictedTitle:
        'Edit the insurance provider so that we can submit your insurance eligibility.',
      phoneInvalid: 'Please enter a valid phone number',
      requiredField: 'This field is required',
      unableToRead: 'Unable to read, please add manually',
    },
  },
  es: {
    editInsurancePage: {
      continue: 'Continuar',
      fillOutNow: 'Complete esto ahora para ahorrar tiempo en su próxima cita',
      insuranceProvider: 'Proveedor de seguros',
      memberIdCharacterMinimum:
        'El ID de Miembro debe tener al menos 1 carácter',
      memberIdInvalidCharacter: 'Por favor ingrese solo letras y números',
      memberIdInvalidFormat: 'Formato no válido, por favor vuelva a ingresar',
      ocrIssueTitle:
        'No se puede leer la información de su tarjeta. Agregue la información que falta para continuar agregando cobertura de seguro.',
      otherPredictedTitle:
        'Edite el proveedor de seguros para que podamos enviar su elegibilidad de seguro.',
      phoneInvalid: 'Por favor ingrese un número de teléfono válido',
      requiredField: 'Este campo es obligatorio',
      unableToRead: 'No se puede leer, agregue manualmente',
    },
  },
};
